module.exports = __webpack_public_path__ + "img/3.a00c73cb.png";